/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import api from '@redux/apis/baseApi'
import { API_RESOURCE } from '@constants/api'
import { formatDateISOString } from '@utils/time'

const CACHE_NAMES = ['Scans']

const statisticsApi = api.injectEndpoints({
  endpoints: build => ({
    getScanResult: build.query<
      Response.Statistics.ScanResultAPI,
      Request.StatisticsGetScanResultParams
    >({
      query: ({ from, to, interval, cursor, limit }) => {
        const qs = Object.entries({
          from: formatDateISOString(from),
          to: formatDateISOString(to),
          interval,
          cursor,
          limit,
        }).reduce((acc, [key, val]) => {
          if (val && key === 'interval') {
            acc.push(`${key}=${val === 'hour' ? '1h' : '1d'}`)
          } else if (val) {
            acc.push(`${key}=${val}`)
          }

          return acc
        }, [])

        return {
          url: `${API_RESOURCE.SCAN}${qs.length > 0 && `?${qs.join('&')}`}`,
        }
      },
    }),
  }),
})

statisticsApi.enhanceEndpoints({
  addTagTypes: CACHE_NAMES,
  endpoints: {
    getScanResult: {
      providesTags: CACHE_NAMES,
    },
  },
})

export default statisticsApi
